import type { DecimalString, Uuid } from './subprojects';

export interface CatalogItem {
  id: Uuid;
  ref: string;
  description: string;
  category_id: Uuid;
  category: string;
  supplier_id: Uuid;
  supplier: string;
  unit_cost: DecimalString;
  pvp: DecimalString;
  desvio_comercial_pct: DecimalString;
  created_at: string;
  updated_at?: string;
  beneficio_comercial_pct: DecimalString;
  cost_real: DecimalString;
  profit_pct?: DecimalString | null;
  stock?: number;
  active?: boolean;
}

export interface CatalogItemFilters {
  search?: string;
  supplier?: string;
  category?: string;
  active?: boolean;
  min_unit_cost?: DecimalString | number;
  max_unit_cost?: DecimalString | number;
  min_pvp?: DecimalString | number;
  max_pvp?: DecimalString | number;
}

export interface CatalogPagination {
  page: number;
  page_size: number;
  total?: number;
  total_pages?: number;
}

export interface CatalogItemsResponse {
  items: CatalogItem[];
  pagination: {
    total: number;
    page: number;
    page_size: number;
    total_pages?: number;
  };
}

export interface CatalogLookups {
  suppliers: string[];
  categories: string[];
}

export function normalizeCatalogItemsResponse(raw: any): CatalogItemsResponse {

  const rawItems = Array.isArray(raw)
    ? raw
    : raw?.items ?? raw?.data?.items ?? raw?.data ?? [];
  const items = Array.isArray(rawItems)
    ? rawItems
    : Array.isArray((rawItems as any).items)
      ? (rawItems as any).items
      : [];

  const pagination = raw?.pagination ?? raw?.data?.pagination ?? {};
  const fallbackPageSize = items.length || 1;

  return {
    items,
    pagination: {
      total: pagination.total ?? raw?.total ?? items.length,
      page: pagination.page ?? raw?.page ?? 1,
      page_size:
        pagination.page_size ??
        raw?.page_size ??
        raw?.per_page ??
        fallbackPageSize,
      total_pages:
        pagination.total_pages ??
        raw?.total_pages ??
        Math.max(
          1,
          Math.ceil(
            (pagination.total ?? raw?.total ?? items.length)
            / (pagination.page_size ?? raw?.page_size ?? raw?.per_page ?? fallbackPageSize),
          ),
        ),
    },
  };
}
